var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB73",
    d: "M21.777 7.614c.506.38.881.917 1.069 1.534.2.612.205 1.274.013 1.89a3.005 3.005 0 0 1-1.08 1.525l-3.264 2.462 1.24 3.965c.192.615.19 1.277-.004 1.892a3.052 3.052 0 0 1-1.082 1.526 2.896 2.896 0 0 1-1.744.577 2.897 2.897 0 0 1-1.739-.594l-3.192-2.424-3.191 2.427a2.853 2.853 0 0 1-1.74.606 2.852 2.852 0 0 1-1.744-.588 3.004 3.004 0 0 1-1.093-1.525 3.104 3.104 0 0 1 .007-1.897l1.24-3.965-3.26-2.462a3.053 3.053 0 0 1-1.07-1.528 3.152 3.152 0 0 1 .003-1.886 3.053 3.053 0 0 1 1.073-1.525 2.896 2.896 0 0 1 1.735-.584H7.96l1.217-3.917a3.054 3.054 0 0 1 1.073-1.536A2.896 2.896 0 0 1 11.994 1c.627 0 1.238.206 1.744.587.506.382.882.92 1.074 1.536l1.216 3.917h4.006a2.852 2.852 0 0 1 1.743.574Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/Star-filled.5ab43736b0d4efb840e621431afab242.svg";
export { ForwardRef as ReactComponent };